import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonsModule, CardModule, IconModule } from '@mastechnicaegroup/carelinelive-ui';
import { Commissioner } from '@lib/api/models/commissioner';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';

@Component({
    selector: 'app-commissioner-general-information',
    imports: [
        ButtonsModule,
        CardModule,
        IconModule,
        AccordionItemComponent
    ],
    templateUrl: './commissioner-general-information.component.html',
    standalone: true,
    styleUrl: './commissioner-general-information.component.scss'
})
export class CommissionerGeneralInformationComponent {
    @Input() commissionerData: Commissioner | undefined;
    @Output() editGeneralInformationEvent: EventEmitter<void> = new EventEmitter<void>();

    editGeneralInformation() {
        window.scrollTo(0, 0);
        this.editGeneralInformationEvent.emit();
    }
}
